export const blockIconsSearchBedroomParent = (
	<span className='material-symbols-outlined'>bedroom_parent</span>
);
